// extracted by mini-css-extract-plugin
module.exports = {"app_loader":"AppLoader_app_loader__JSRQ4","light":"AppLoader_light__HyuS5","indicator":"AppLoader_indicator__5iIqn","scale_animate":"AppLoader_scale_animate__SKibS"};